import React from "react";
import styled from "styled-components";
import Link from "next/link";
import {device} from "../../constants/media";

const Container = styled.a`
  @media ${device.below.tablet} {
    max-width: 150px;
    width: 40%;
    margin: 0.5rem;
  }
  @media ${device.below.mobileS} {
    width: 80%;
    margin: 1.5rem auto;
    max-width: 1000px;
  }
  width: 150px;

  display: flex;
  flex-direction: column;
  margin: 1.5rem;
  cursor: pointer;
  text-decoration: none;
`;

const Image = styled.img`
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  color: #222;
  text-justify: none;
  justify-content: space-between;
  font-weight: bold;
  align-items: center;
`;

const Title = styled.div`
  margin: 0;
  font-size: 0.6rem;
`;

const WinCount = styled.div`
  font-size: 2rem;
  white-space: nowrap;
`;

class AwardItem extends React.Component {
  render() {
    const award = this.props.award;
    return (
      <Link href={"/practice/awards/" + award.slug} passHref>
        <Container>
          <Image src={award.cover} />
          <TitleContainer>
            <Title>{award.title}</Title>
            <WinCount>&nbsp;{award.win_count}</WinCount>
          </TitleContainer>
        </Container>
      </Link>
    );
  }
}

export default AwardItem;
